import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
var O = Object;
export default (function () {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }
  return a.flatMap(function (x) {
    return x && O.getPrototypeOf(x) === O.prototype ? O.entries(x).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      return v && k;
    }) : x;
  }).filter(function (s) {
    return s && s.trim;
  }).join(' ');
});